export const smallScreenHeight = '830px';
